<template>
  <div class="data-table">
    <div class="head">
      <div class="head-action">
        <a-button type="primary" @click="edit(0)">新增</a-button>
        <a-button type="primary" @click="changPwd">修改密码</a-button>
        <a-button type="primary" @click="clearPwd">清除密码</a-button>
        <a-button type="primary" @click="disabled">{{
          selectRowData.Status != 1 ? "启用" : "禁用"
        }}</a-button>
        <a-button type="primary" @click="charge">充值</a-button>
        <a-button type="primary" @click="consume">消费</a-button>
        <a-button type="primary" @click="addPoint">手动积分</a-button>
        <a-button type="primary" @click="exchange">积分兑换</a-button>
        <a-button type="primary" @click="fileDown">下载模板</a-button>
        <upLoadImage
          style="margin-left:10px"
          v-model="backUrl"
          :imageUrl="false"
          listType="text"
          text="导入"
          mode="file"
          @update="fileImport"
        />
      </div>
      <div class="head-search">
        <div class="head-search-box" style="width:290px;">
          <div class="head-search-button">
            <a-form :form="option.headSearchForm" layout="inline">
              <a-form-item>
                <a-input
                  placeholder="请输入手机号/姓名/卡号/卡Id"
                  v-model="Keyword"
                  @pressEnter="normalSearch"
                />
              </a-form-item>
              <a-form-item>
                <a-button type="primary" @click="normalSearch">查询</a-button>
                <!-- <a-button @click="advancedQuery">高级查询</a-button> -->
              </a-form-item>
            </a-form>
          </div>
        </div>
      </div>
    </div>
    <dataGrid
      ref="dataGrid"
      v-model="data"
      :params="option.params"
      :columns="option.columns"
      :pagination="true"
      :url="url.MemberInfoGetList"
      @selectRow="selectRow"
      @update="gridUpdate"
      bordered
      :props="props"
    >
    </dataGrid>
    <advancedQuery ref="advancedQuery"></advancedQuery>
    <memberCharge ref="memberCharge" @submit="updateGrid"></memberCharge>
    <memberConsume ref="memberConsume" @submit="updateGrid"></memberConsume>
    <memberChangePwd
      ref="memberChangePwd"
      @submit="updateGrid"
    ></memberChangePwd>
    <Edit ref="Edit" @submit="updateGrid"></Edit>
    <ponitExchange ref="ponitExchange" @submit="updateGrid"></ponitExchange>
    <ponitAdd ref="ponitAdd" @submit="updateGrid"></ponitAdd>
    <a-modal
      title="提示"
      :visible="visible"
      :footer="null"
      @cancel="visible = false"
    >
      <p class="tip-info">
        会员信息填写有误，可以点击该链接<span class="file" @click="editFile">
          {{ docUrl }}</span
        >下载文档，根据文档提示修改后重新导入！
      </p>
    </a-modal>
  </div>
</template>
<script>
import { cache } from "@/utils/common.js";
import dataGrid from "@/components/dataGrid/DataGrid";
import Edit from "@/views/groupMember/manage/Edit";
import advancedQuery from "./manage/AdvancedQuery";
import memberCharge from "@/views/groupMember/manage/MemberCharge";
import memberConsume from "@/views/groupMember/manage/MemberConsume";
import memberChangePwd from "@/views/groupMember/manage/MemberChangePwd";
import ponitExchange from "@/views/groupMember/manage/PonitExchange";
import ponitAdd from "@/views/groupMember/manage/PonitAdd";
import upLoadImage from "@/components/tools/upLoadImage";
import { exportsDownLoad } from "@/utils/common";
export default {
  name: "CustomerManage",
  components: {
    dataGrid,
    Edit,
    advancedQuery,
    memberCharge,
    memberConsume,
    memberChangePwd,
    upLoadImage,
    ponitExchange,
    ponitAdd
  },
  data() {
    return {
      //选中行
      selectRowData: {},
      Keyword: "",
      loading: false,
      data: [],
      props: {
        scroll: {
          x: 1500,
          y: window.document.body.clientHeight - 330
        }
      },
      option: {
        params: {},
        headSearchForm: this.$form.createForm(this),
        columns: [
          {
            title: "序号",
            width: 60,
            align: "center",
            type: "indexcolumn"
          },
          {
            title: "状态",
            width: 80,
            customRender: (text, record) => {
              let name = "";
              switch (record.Status) {
                case "0":
                  name = "未发";
                  break;
                case "1":
                  name = "启用";
                  break;
                case "2":
                  name = "发卡失败";
                  break;
                case "3":
                  name = "挂失";
                  break;
                case "4":
                  name = "禁用";
                  break;
              }
              return <div>{name}</div>;
            }
          },
          {
            title: "卡类",
            width: 150,
            dataIndex: "MemberCardTypeName"
          },
          {
            title: "卡号",
            width: 170,
            dataIndex: "CardNo"
          },
          {
            title: "姓名",
            width: 150,
            dataIndex: "Name"
          },
          {
            title: "电话",
            width: 150,
            dataIndex: "Phone"
          },

          {
            title: "消费总额",
            width: 100,
            align: "right",
            dataIndex: "ConsumeTotalAmount"
          },
          {
            title: "余额",
            width: 100,
            align: "right",
            dataIndex: "Balance"
          },
          {
            title: "积分总额",
            width: 100,
            align: "right",
            dataIndex: "PointTotalAmount"
          },
          {
            title: "积分余额",
            width: 100,
            align: "right",
            dataIndex: "PointBalance"
          },
          {
            title: "总房晚",
            dataIndex: "TotalNights"
          },
          {
            title: "操作",
            fixed: "right",
            width: 250,
            align: "center",
            customRender: (text, record) => {
              return (
                <div>
                  <a-button
                    size="small"
                    type="link"
                    {...{
                      on: {
                        click: this.edit.bind(null, 1, record)
                      }
                    }}
                  >
                    编辑
                  </a-button>
                  <div class="ant-divider ant-divider-vertical" />
                  <a-button
                    size="small"
                    type="link"
                    {...{
                      on: {
                        click: this.edit.bind(null, 2, record)
                      }
                    }}
                  >
                    查看
                  </a-button>
                  <div class="ant-divider ant-divider-vertical" />
                  <a-button
                    size="small"
                    type="link"
                    {...{
                      on: {
                        click: this.delete.bind(null, record)
                      }
                    }}
                  >
                    删除
                  </a-button>
                </div>
              );
            }
          }
        ]
      },
      backUrl: "",
      visible: false,
      docUrl: ""
    };
  },
  created() {
    this.user = cache.get("user");
    var url = {
      MemberInfoGetList: "MemberInfoGetList",
      MemberInfoDelete: "MemberInfoDelete",
      MemberUpdatePassword: "MemberUpdatePassword",
      MemberUpdateStatus: "MemberUpdateStatus"
    };
    if (this.user.IsGroupSystem) {
      for (let i in url) {
        url[i] = "Group" + url[i];
      }
    }
    this.url = url;
  },
  methods: {
    normalSearch() {
      this.search({
        Keyword: this.Keyword
      });
    },
    search(params) {
      this.option.params = params;
    },
    advancedQuery() {
      this.$refs.advancedQuery.show();
      // AdvancedQueryModal();
    },
    edit(type, row) {
      if (type == 0) {
        row = { Id: "0" };
      }
      if (!row && type > 0) {
        this.$message.info("请先选择一条数据！");
        return false;
      }
      this.$refs.Edit.show(type, row.Id);
    },
    delete(row) {
      this.$confirm({
        title: "是否确认删除?",
        okText: "确认",
        cancelText: "取消",
        onOk: () => {
          this.$post(this.url.MemberInfoDelete, {
            Id: row.Id
          }).then(res => {
            if (res.Data) {
              this.updateGrid();
            }
          });
        }
      });
    },
    changPwd() {
      let row = this.$refs.dataGrid.getSelected();
      if (!row) {
        this.$message.info("请先选择一条数据！");
        return false;
      }
      this.$refs.memberChangePwd.show(row.Id);
    },
    clearPwd() {
      let row = this.$refs.dataGrid.getSelected();
      if (!row) {
        this.$message.info("请先选择一条数据！");
        return false;
      }
      this.$confirm({
        title: "是否确认清空密码?",
        okText: "确认",
        cancelText: "取消",
        onOk: () => {
          this.$post(this.url.MemberUpdatePassword, {
            MemberCardId: row.Id,
            IsReset: true
          }).then(res => {
            if (res.Data) {
              this.$message.success("清空密码成功");
              this.updateGrid();
            }
          });
        }
      });
    },
    charge() {
      let row = this.$refs.dataGrid.getSelected();
      if (!row) {
        this.$message.info("请先选择一条数据！");
        return false;
      }
      if (row.Status != 1) {
        this.$message.info("会员未启用");
        return false;
      }
      this.$refs.memberCharge.show(row.Id);
    },
    consume() {
      let row = this.$refs.dataGrid.getSelected();
      if (!row) {
        this.$message.info("请先选择一条数据！");
        return false;
      }
      if (row.Status != 1) {
        this.$message.info("会员未启用");
        return false;
      }
      this.$refs.memberConsume.show(row.Id);
    },
    //手动积分
    addPoint() {
      let row = this.$refs.dataGrid.getSelected();
      if (!row) {
        this.$message.info("请先选择一条数据！");
        return false;
      }
      this.$refs.ponitAdd.show(row.Id);
    },
    exchange() {
      let row = this.$refs.dataGrid.getSelected();
      if (!row) {
        this.$message.info("请先选择一条数据！");
        return false;
      }
      this.$refs.ponitExchange.show(row.Id);
    },
    disabled() {
      let row = this.$refs.dataGrid.getSelected();
      if (!row) {
        this.$message.info("请先选择一条数据！");
        return false;
      }
      this.$post(this.url.MemberUpdateStatus, {
        Id: row.Id,
        Status: row.Status != 1 ? 1 : 4
      }).then(res => {
        if (res.Data) {
          this.updateGrid();
        }
      });
    },
    updateGrid() {
      this.$refs.dataGrid.reload();
    },
    gridUpdate() {
      this.selectRowData = {};
    },
    selectRow(row) {
      this.selectRowData = row;
    },
    /////////
    // Isxpush(val) {
    //   if (val) {
    //     this.loading = true;
    //     setTimeout(() => {
    //       this.loading = false;
    //     }, 50);
    //   }
    // }
    //下载模板
    fileDown() {
      let url = this.$config.serverUrl + "" + "/api/MemberInfo/FileDown";
      exportsDownLoad(url);
    },
    //导入
    fileImport() {
      const _this = this;
      this.$confirm({
        title: "确定导入吗?",
        okText: "确定",
        cancelText: "取消",
        onOk() {
          _this
            .$post(
              "MemberFileImport",
              { Path: _this.backUrl },
              { alertError: false }
            )
            .then(res => {
              // this.$message.success("上传成功！");
              _this.$info({
                title: "提示",
                content: res.Data.Infos,
                onOk() {
                  _this.$refs.dataGrid.reload();
                }
              });
            })
            .catch(err => {
              if (err.data.Code == "-1") {
                _this.visible = true;
                // const str = "tempfiles" + err.data.Message.split("tempfiles")[1];
                _this.docUrl = err.data.Message;
              } else {
                const h = _this.$createElement;
                const arr = err.data.Message.split("\r\n").map(el => {
                  return h("p", el);
                });
                _this.$error({
                  title: "提示",
                  content: h("div", [arr])
                });
              }
            });
        },
        onCancel() {}
      });
    },
    editFile() {
      let url = this.$config.serverUrl + "/" + this.docUrl;
      exportsDownLoad(url);
    }
  }
};
</script>

<style lang="less" scoped>
.data-table {
  position: relative;
  overflow: hidden;
  min-height: calc(100vh - 200px);
}

.data-table .head {
  display: flex;
}

.data-table .head .head-action {
  margin-bottom: 10px;
  margin-top: 5px;
}

.data-table .head .head-search {
  text-align: right;
  -webkit-box-flex: 1;
  -ms-flex: 1;
  flex: 1;
}
.data-table .head .head-search-box .head-search-button {
  margin-left: 16px;
  margin-top: 3px;
}

.data-table .head .head-search-box {
  display: flex;
  float: right;
  text-align: left;
}

.ant-btn + .ant-btn {
  margin-left: 10px;
}
.tip-info {
  padding: 30px 20px 50px;
  font-size: 16px;
}
.file {
  color: #1890ff;
  text-decoration: underline;
  cursor: pointer;
}
</style>
